const getDeviceSO = ()=>{
    const { userAgent, platform, maxTouchPoints } = navigator;
    const hasAndroidPattern = /Android/i.test(userAgent);
    const isWindowsPhone = /Windows Phone/i.test(userAgent);
    const isAndroid = hasAndroidPattern && !isWindowsPhone;
    const isWindows = [
        'Win32',
        'Win64',
        'Windows',
        'WinCE'
    ].includes(platform);
    const isIOS = (/iPad|iPhone|iPod/.test(userAgent) || 'MacIntel' === platform && maxTouchPoints > 1) && !window.MSStream;
    const isMac = [
        'Macintosh',
        'MacIntel',
        'MacPPC',
        'Mac68K'
    ].includes(platform) && !isIOS;
    return {
        isAndroid,
        isIOS,
        isMac,
        isWindows,
        isWindowsPhone
    };
};
const src_getDeviceSO = getDeviceSO;
export default src_getDeviceSO;
